import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { label: "Solutions", href: "#solutions" },
  { label: "Simulators", href: "#simulators" },
  { label: "Events", href: "#events" },
  { label: "Our Team", href: "#team" },
  { label: "Gallery", href: "#gallery" },
];

export const Navbar = ({ onNavigate, onQuote }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    onNavigate(href);
  };

  const navBg =
    scrolled || open
      ? "bg-ink/85 backdrop-blur-md border-line"
      : "bg-ink/40 backdrop-blur-md border-white/5";

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 border-b backdrop-blur-md transition-colors duration-300 ${navBg}`}
      data-testid="main-nav"
    >
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between gap-4">
        <Logo />
        <div className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="relative text-xs font-mono uppercase tracking-[0.2em] text-slate-400 hover:text-slate-50 transition-colors duration-200 group py-1"
            >
              {l.label}
              <span className="absolute -bottom-0.5 left-0 h-px w-0 bg-electric transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={onQuote}
            data-testid="nav-quote-btn"
            className="hidden sm:inline-flex items-center bg-electric text-ink font-display font-bold text-xs uppercase tracking-[0.15em] px-5 py-2.5 clip-corner hover:bg-electric-hover transition-colors duration-200"
          >
            Request a Quote
          </button>
          <button
            className="lg:hidden text-slate-200 p-1"
            onClick={() => setOpen(!open)}
            data-testid="nav-mobile-toggle"
            aria-label="Toggle navigation menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </nav>
      {open && (
        <div className="lg:hidden border-t border-line bg-ink/95 backdrop-blur-md" data-testid="nav-mobile-menu">
          <div className="px-4 py-4 flex flex-col">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => go(e, l.href)}
                className="py-3.5 px-2 text-sm font-mono uppercase tracking-[0.2em] text-slate-300 hover:text-electric border-b border-line/60 transition-colors"
              >
                {l.label}
              </a>
            ))}
            <button
              onClick={() => {
                setOpen(false);
                onQuote();
              }}
              data-testid="nav-mobile-quote-btn"
              className="mt-4 bg-electric text-ink font-display font-bold text-sm uppercase tracking-[0.15em] px-5 py-3.5"
            >
              Request a Quote
            </button>
          </div>
        </div>
      )}
    </header>
  );
};
